import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'


const BedTypes = () => {
            const navigate = useNavigate();
  
  const [bedTypes, setBedTypes] = useState([]);
  const [form, setForm] = useState({ bedtype: '' });
  const [isEdit, setIsEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getBedTypes = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-bedtypes`, {
      withCredentials: true
    })
      .then(res => {
        setBedTypes(res.data.bedtypes || []);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  useEffect(() => {
    getBedTypes();
  }, []);

  const openAddModal = () => {
    setForm({ bedtype: '' });
    setIsEdit(false);
    setShowModal(true);
    setSelectedId(null);
  };

  const openEditModal = (bt) => {
    setForm({ bedtype: bt.bedtype });
    setIsEdit(true);
    setShowModal(true);
    setSelectedId(bt.id);
  };

  const validateBedTypeForm = () => {

    if (!form.bedtype?.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please enter a bed type name.'
      });
      return false;
    }
    return true;
  };

  const saveBedType = () => {
    if (!validateBedTypeForm()) return;

    axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/create-bedtype`, form, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          Swal.fire('Success', 'Bed type added!', 'success');
          setShowModal(false);
          getBedTypes();
        }
      })
      .catch(err =>globalErrorHandler(err, navigate));
  };

  const updateBedType = () => {
    if (!validateBedTypeForm()) return;

    axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/update-bedtype`, { ...form, id: selectedId }, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          Swal.fire('Success', 'Bed type updated!', 'success');
          setShowModal(false);
          getBedTypes();
        }
      })
      .catch(err =>globalErrorHandler(err, navigate));
  };

  const deleteBedType = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will permanently delete the bed type.',
      icon: 'warning',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/delete-bedtype`, { id }, { withCredentials: true })
          .then(res => {
            if (res.data.status) {
              Swal.fire('Deleted!', res.data.message, 'success');
              getBedTypes();
            }
          })
          .catch(err =>globalErrorHandler(err, navigate));
      }
    });
  };

  return (
    <div className="container-fluid px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Bed Types</h3>
        <Button variant="success" onClick={openAddModal}>Add New Bed Type</Button>
      </div>
      <table className="table table-bordered table-hover shadow-sm">
        <thead className="table-success">
          <tr>
            <th>Bed Type</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="2">Loading...</td></tr>
          ) : bedTypes.length === 0 ? (
            <tr><td colSpan="2">No data found.</td></tr>
          ) : (
            bedTypes.map(bt => (
              <tr key={bt.id}>
                <td>{bt.bedtype}</td>
                <td>
                  <Button variant="info" className="me-2" onClick={() => openEditModal(bt)}>Edit</Button>
                  <Button variant="danger" onClick={() => deleteBedType(bt.id)}>Delete</Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? 'Edit Bed Type' : 'Add Bed Type'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Bed Type</label>
            <input
              type="text"
              className="form-control"
              value={form.bedtype}
              onChange={(e) => setForm({ ...form, bedtype: e.target.value })}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={isEdit ? updateBedType : saveBedType}>
            {isEdit ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default BedTypes;
